import { render } from "./ClassRoomList.vue?vue&type=template&id=739c46d7&scoped=true&ts=true"
import script from "./ClassRoomList.vue?vue&type=script&lang=ts"
export * from "./ClassRoomList.vue?vue&type=script&lang=ts"

import "./ClassRoomList.vue?vue&type=style&index=0&id=739c46d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739c46d7"]])

export default __exports__